import { useEffect, useState } from 'react'

import { AttachmentDataWithRequiredAttachment } from '../../../../../../../../../../@types/types'

export const usePictureSelection = (pictureAttachments: AttachmentDataWithRequiredAttachment[]) => {
  const [selection, setSelection] = useState(() => ({
    imageId: pictureAttachments[0]?.attachment.id,
    index: 0,
  }))
  const currentImageIndex = pictureAttachments.findIndex(({ attachment }) => attachment.id === selection.imageId)
  const selectedImageIndex =
    currentImageIndex >= 0 ? currentImageIndex : Math.min(selection.index, pictureAttachments.length - 1)
  const selectedImageId = pictureAttachments[selectedImageIndex]?.attachment.id

  useEffect(() => {
    const normalizedSelection = {
      imageId: selectedImageId,
      index: Math.max(selectedImageIndex, 0),
    }
    if (selection.imageId !== normalizedSelection.imageId || selection.index !== normalizedSelection.index) {
      setSelection(normalizedSelection)
    }
  }, [selectedImageId, selectedImageIndex, selection.imageId, selection.index])

  const selectImage = (imageId: string) => {
    const index = pictureAttachments.findIndex(({ attachment }) => attachment.id === imageId)
    if (index >= 0) setSelection({ imageId, index })
  }

  return {
    selectedImageId,
    selectImage,
  }
}
